import http from "./httpService";
const url = "https://wms.advanceagro.net/ws2/api";
//const url = "http://127.0.0.1:8080/api";

export async function pclist(
  year = "2020",
  start = "",
  end = "",
  SiteID = "",
  locationid = "0",
  search = "",
  pageSize = 1000,
  pageNumber = 1,statusid=0,checkby ="0",code=""
) {
  return http.get(
    url+"/PCCheck/PCList?startdate=" +
      start +
      "&enddate=" +
      end +
      "&siteid=" +
      SiteID +
      "&locationid=" +
      locationid +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber +
      "&search=" +
      search +
      "&year=" +
      year +"&statusid="+statusid +"&checkby=" + checkby +"&code="+code
  );
}
export async function getImageType(code="") {
  return http.get(url +"/PCCheck/getimagetype?code="+code);
}
export async function getCheckingPerson(code="") {
  return http.get(url +"/PCCheck/getCheckingPerson?code="+code);
}

export async function getSite(code="") {
  return http.get(url +"/PCCheck/getSite?code="+code);
}
export async function getSiteSelected(code="") {
  return http.get(url +"/PCCheck/getSiteSelected?code="+code);
}

export async function getChipMacSelected() {
  return http.get(url +"/PCCheck/getChipMacSelected");
}
export async function getModelMacSelected() {
  return http.get(url +"/PCCheck/getModelMacSelected");
}
export async function getOSMacSelected() {
  return http.get(url +"/PCCheck/getOSMacSelected");
}
export async function getSoftwareMac() {
  return http.get(url +"/PCCheck/getSoftwareMac");
}

export async function GetMyRegis() {
  return http.get(url +"/PCCheck/GetMyRegis");
}
export async function saveMacbookRegister(doc) {
  return http.post(url +"/PCCheck/saveMacbookRegister",doc);
}
export async function deleteMacRegist(doc) {
  return http.post(url +"/PCCheck/deleteMacRegist",doc);
}



export async function getLocation(id =0,code="") {
  return http.get(url +"/PCCheck/getLocation?id="+ id +"&code="+code);
}
export async function getLocationSelected(id =0,code="") {
  return http.get(url +"/PCCheck/getLocationSelected?id="+ id +"&code="+code);
}
export async function getImagelist(id,code="") {
  return http.get(url +"/PCCheck/getImagelist?id=" +id+"&code="+code);
}

export async function getManuallist() {
  return http.get(url +"/PCCheck/getManuallist");
}

export async function getdashboard(code="") {
  return http.get(url +"/PCCheck/getDashboard?code="+code);
}
export async function getdashboardPC(code="") {
  return http.get(url +"/PCCheck/getDashboardPCNotebook?code="+code);
}
export async function getdashboardcheckdate(code="") {
  return http.get(url +"/PCCheck/getDashboardDateChecking?code="+code);
}


export async function getdashboardOS(code="") {
  return http.get(url +"/PCCheck/getDashboardOS?code="+code);
}
export async function getdashboardSoftware(code="") {
  return http.get(url +"/PCCheck/getDashboardSoftwarelist?code="+code);
}
export async function getdashboardAge(code="") {
  return http.get(url +"/PCCheck/getDashboardage?code="+code);
}

export async function saveImage(doc,code="") {
  return http.post("https://wms.advanceagro.net/WS2/api/PCCheck/UploadImage?code="+code, doc);
}